// extracted by mini-css-extract-plugin
export default {"activeColor":"#ff4156","inactiveColor":"#808c9c","header":"header__3w31z","label-active":"label-active__PPDKb"};
    if(module.hot) {
      // 1764953372871
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  